import * as t from 'io-ts';
import { nonEmptyString, dateString, stringEnum } from '../utils';

export enum RunningIn {
  Local = 'local',
  DevServer = 'devserver',
  Production = 'production',
}

const DeployInfo = t.exact(t.interface({
  branch: nonEmptyString,
  revision: nonEmptyString,
  date: dateString,
  runningIn: stringEnum<RunningIn>(RunningIn, 'RunningIn'),
  serverName: t.union([nonEmptyString, t.null]),
}), 'DeployInfo');

export type IDeployInfo = t.TypeOf<typeof DeployInfo>;

export default DeployInfo;
